import React, { useEffect } from 'react';
import Footer from './common/home/Footer';
import TopBar from './common/home/TopBar';
import { 
  List, 
  ListItem, 
  ListItemText, 
  ListSubheader, 
  Typography 
} from '@mui/material';
import { homeBackground } from './common/ColorCodes';
import './common/Styles.css'
import { CONST_BUSINESS_NAME, CONST_BUSINESS_MAIL, CONST_SITE_LABEL } from './common/Helper';

export const TermsAndConditions = () => {

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | Terms & Conditions`
  }, [])

  return (
    <div style={{ backgroundColor: homeBackground }}>
      <TopBar />

      <div className='policy-container'>
        <Typography variant={'h5'}>Terms and Conditions for {CONST_SITE_LABEL}</Typography>

        <List>
          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">1. Introduction</ListSubheader>
            <ListItemText className='list-item-text'>Welcome to {CONST_SITE_LABEL} ({CONST_BUSINESS_NAME})! These Terms and Conditions
              govern your use of our web application and any related services provided by us.</ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">2. Acceptance of Terms</ListSubheader>
            <ListItemText className='list-item-text'>By accessing or using {CONST_SITE_LABEL}, you agree to be bound by these Terms and
              Conditions and our Privacy Policy. If you do not agree with any part of these terms, you may not
              access or use the application.</ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">3. Description of Service</ListSubheader>
            <ListItemText className='list-item-text'>
              <List className='sublist'>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    3.1 {CONST_SITE_LABEL} provides AWS account recommendations and cost optimization services by
                    analyzing data from your AWS cloud infrastructure.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item '>
                  <ListItemText className='list-item-text'>
                    3.2. Our recommendations are based on algorithms and analysis of your AWS usage patterns,
                    with the aim of optimizing costs and improving efficiency.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">4. Account Registration</ListSubheader>
            <ListItemText className='list-item-text'>
              <List className='sublist'>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    4.1 You must register for an account to access {CONST_SITE_LABEL}. You agree to provide accurate
                    and complete information during the registration process.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    4.2. You are responsible for maintaining the confidentiality of your account credentials and for all
                    activities that occur under your account.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">5. Use of Service</ListSubheader>
            <ListItemText className='list-item-text'>
              <List className='sublist'>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    5.1 You agree to use {CONST_SITE_LABEL} only for lawful purposes and in compliance with all
                    applicable laws and regulations.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    5.2. You may not use {CONST_SITE_LABEL} in any manner that could damage, disable, overburden,
                    or impair our servers or networks.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">6. Recommendations and Results</ListSubheader>
            <ListItemText className='list-item-text'>
              <List className='sublist'>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    6.1 While we strive to provide accurate recommendations, we do not guarantee the accuracy,
                    completeness, or reliability of any recommendations or results provided by {CONST_SITE_LABEL}.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    6.2. You acknowledge that AWS account recommendations are based on data analysis and may
                    not always reflect your specific requirements or circumstances.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">7. Data Privacy</ListSubheader>
            <ListItemText className='list-item-text'>
              <List className='sublist'>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    7.1 We collect and process data generated by your use of {CONST_SITE_LABEL} in accordance with
                    our Privacy Policy.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    7.2. By using {CONST_SITE_LABEL}, you consent to the collection, processing, and use of your data
                    as described in our Privacy Policy.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">8. Limitation of Liability</ListSubheader>
            <ListItemText className='list-item-text'>8.1. In no event shall {CONST_SITE_LABEL} or its affiliates, directors, officers, employees, agents, or
              licensors be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses,
              resulting from your use of {CONST_SITE_LABEL}.</ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">9. Governing Law</ListSubheader>
            <ListItemText className='list-item-text'>These Terms and Conditions shall be governed by and construed in accordance with the laws of
              India, without regard to its conflict of law provisions.</ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">10. Changes to Terms</ListSubheader>
            <ListItemText className='list-item-text'>We reserve the right to modify or replace these Terms and Conditions at any time. Any changes
              will be effective immediately upon posting the updated Terms and Conditions on our website.</ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">11. Contact Us</ListSubheader>
            <ListItemText className='list-item-text'>If you have any questions or concerns about these Terms and Conditions, please contact us at
              {' '}<span className='item-bold'>{CONST_BUSINESS_MAIL}</span></ListItemText>
          </ListItem>

        </List>
      </div>

      <Footer />
    </div>
  )
}
